var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconCarbonOffset128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_19444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.2559 58.7231H67.3223L69.8556 112.765H59.7227L62.2559 58.7231Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7891 58.7234C69.4526 58.7234 73.2331 49.272 73.2331 37.6131C73.2331 25.9543 69.4526 16.5029 64.7891 16.5029C60.1255 16.5029 56.345 25.9543 56.345 37.6131C56.345 49.272 60.1255 58.7234 64.7891 58.7234Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1667 62.1008C66.1958 66.3274 73.1639 73.7481 83.7304 78.6753C94.2969 83.6026 104.46 84.1706 106.431 79.944C108.402 75.7174 101.434 68.2967 90.8677 63.3695C80.3011 58.4422 70.1376 57.8742 68.1667 62.1008Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8333 62.1008C62.8042 66.3274 55.8361 73.7481 45.2696 78.6753C34.7031 83.6026 24.5395 84.1706 22.5686 79.944C20.5977 75.7174 27.5658 68.2967 38.1323 63.3695C48.6989 58.4422 58.8624 57.8742 60.8333 62.1008Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7889 72.2341C70.3852 72.2341 74.9218 67.6974 74.9218 62.1012C74.9218 56.5049 70.3852 51.9683 64.7889 51.9683C59.1927 51.9683 54.656 56.5049 54.656 62.1012C54.656 67.6974 59.1927 72.2341 64.7889 72.2341Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_19444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconCarbonOffset128);
export default __webpack_public_path__ + "static/media/pictogramBeaconCarbonOffset128.ab8ffb93e418944280bc3a70a1b4386f.svg";
export { ForwardRef as ReactComponent };